import { connect } from "vuex-connect";
import { MyContentsSettings } from "../../../components";

export default connect({
  stateToProps: {
    updatedThumbnailIdentificationCode: state =>
      state.myContents.updatedThumbnailIdentificationCode,
    userThumbnailCroppedImageUrl: state =>
      state.myContents.userThumbnailCroppedImageUrl,
    updatedSocialMediaImageIdentificationCode: state =>
      state.myContents.updatedSocialMediaImageIdentificationCode,
    userCroppedSocialMediaImageUrl: state =>
      state.myContents.userCroppedSocialMediaImageUrl
  },
  actionsToProps: {
    saveSettingsChanges: (dispatch, value) => {
      return dispatch("myContents/saveSettingsChanges", value);
    }
  },
  mutationsToProps: {
    setMyContentsThumbnailImageUrl: (commit, value) => {
      return commit("myContents/setMyContentsThumbnailImageUrl", value);
    },
    setSocialMediaImageUrl: (commit, value) => {
      return commit("myContents/setSocialMediaImageUrl", value);
    },
    setContentsIdentificationCode: (commit, value) => {
      return commit("myContents/setContentsIdentificationCode", value);
    }
  }
})(MyContentsSettings.name, MyContentsSettings);
